import React from 'react';
import ProductCard from './ProductCard'; // Importer le composant ProductCard
// Importez Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Importez les modules nécessaires (Pagination, Navigation, Autoplay)
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

// Importez les styles Swiper
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './FeaturedProducts.css'; // Fichier CSS pour la section

// Données d'exemple pour les produits
const featuredProductsData = [
  {
    id: 1,
    name: "Tomme des Pyrénées",
    description: "Fromage au lait de vache pasteurisé, pâte pressée non cuite, affinage doux.",
    imageSrc: "/images/g3.jpg" // Assurez-vous que ce chemin est correct depuis la racine 'public'
  },
  {
    id: 2,
    name: "Rocamadour AOP",
    description: "Petit fromage de chèvre au lait cru, crémeux et fondant, saveur délicate.",
    imageSrc: "/images/g4.jpg" // Assurez-vous que ce chemin est correct depuis la racine 'public'
  },
  {
    id: 3,
    name: "Bleu des Causses AOP",
    description: "Pâte persillée au lait cru de vache, caractère affirmé et texture onctueuse.",
    imageSrc: "/images/g5.jpg" // Assurez-vous que ce chemin est correct depuis la racine 'public'
  },
    // Décommentez pour ajouter plus de produits
    {
      id: 4,
      name: "Pérail de Brebis",
      description: "Fromage doux et crémeux au lait cru de brebis, typique de l'Aveyron.",
      imageSrc: "/images/g2.jpg" // Remplacé par une image existante pour l'exemple
    },
    {
      id: 5,
      name: "Brebis Pur Brebis",
      description: "Fromage au lait cru de brebis, saveur douce et texture ferme.",
      imageSrc: "/images/g1.jpg" // Remplacé par une image existante pour l'exemple
    }
];

function FeaturedProducts() {
  return (
    <section id="products" className="featured-products-section">
      <div className="container">
        <h2 className="section-title">Notre Sélection du Moment</h2>
        <p className="section-subtitle">
          Découvrez quelques-uns de nos fromages coups de cœur, sélectionnés et affinés par nos soins.
        </p>

        {/* Remplacer le slider manuel par Swiper */}
        <Swiper
          // Modules à utiliser (pagination, navigation, autoplay)
          modules={[Pagination, Navigation, Autoplay]}
          spaceBetween={30} // Espace entre les slides
          slidesPerView={1} // Une slide par défaut sur mobile
          loop={true} // Active la boucle infinie
          autoplay={{
            delay: 3000, // Délai entre chaque slide (en ms), ajustez si besoin
            disableOnInteraction: false, // Ne pas arrêter l'autoplay si l'utilisateur interagit
          }}
          pagination={{ clickable: true }} // Active la pagination cliquable
          navigation={true} // Active les flèches de navigation
          centeredSlides={false} // Les slides ne sont pas centrées par défaut
          breakpoints={{
            // Quand la largeur de l'écran est >= 768px (tablette)
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            // Quand la largeur de l'écran est >= 1024px (desktop)
            1024: {
              slidesPerView: 3,
              spaceBetween: 50,
            },
          }}
          className="myFeaturedProductsSwiper" // Nom de classe pour styliser ce Swiper
        >
          {/* On boucle sur les données et on crée une SwiperSlide pour chaque produit */}
          {featuredProductsData.map(product => (
            <SwiperSlide key={product.id}>
              <ProductCard
                name={product.name}
                description={product.description}
                imageSrc={product.imageSrc}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default FeaturedProducts;